import React, { Component } from "react";

const Header = (props) => {
    const { cuentaDatos, vistaCliente } = props.data;

    let denominacion = vistaCliente.client.RazonSocial;
    let administradora = vistaCliente.GET_ADMINISTRADORA[0].Descripcion;
    let denominacionCuenta = cuentaDatos ? cuentaDatos.CuentaDenominacion + " - " + cuentaDatos.Descripcion : "";

    return <div className="row bottom-separator-xs" >
        <div className="col-md-9">
            <label className="label-primary">{denominacion}   ❯   {administradora}   ❯   {denominacionCuenta}   ❯   Tarjetas</label>
        </div>
    </div>
}

export default Header;